export default __webpack_public_path__ + "static/media/mn_tea_head_4.585ced21.png";